export default "__VITE_ASSET__BzrkzqRC__"